module.exports = __webpack_public_path__ + "img/art-work-icon15.ecf08666.png";